import React from 'react';
import { BsArrowRight } from 'react-icons/bs';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.min.css';
import HeroBg1 from '../../assets/img/home1/hero1.jpg';

function Hero1() {
    return (
        <section className="hero-slide-wrapper hero-1">
            <Swiper className="hero-slider-active owl-carousel">
                <SwiperSlide>
                    <div
                        className="single-slide bg-cover"
                        style={{ backgroundImage: `url(${HeroBg1})` }}
                    >
                        <div className="container">
                            <div className="row">
                                <div className="col-12 col-lg-8 col-xl-6">
                                    <div className="hero-contents">
                                        <h1>Împreună îți construim viitorul</h1>
                                        <p>Bine ați venit la Work Express, unde beneficiați de servicii profesionale de construcții și renovări. Echipa noastră de experți vă asigură calitate, eficiență și satisfacție în fiecare proiect.</p>
                                        <Link to="/servicii" className="theme-btn">
                                            Serviciile Noastre{' '}
                                            <BsArrowRight style={{ marginLeft: '10px' }} />
                                        </Link>
                                        <Link to="/despre-noi" className="theme-btn black">
                                            Despre Noi
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div
                        className="single-slide bg-cover"
                        style={{ backgroundImage: `url(${HeroBg1})` }}
                    >
                        <div className="container">
                            <div className="row">
                                <div className="col-12 col-lg-8 col-xl-6">
                                    <div className="hero-contents">
                                        <h1>Work Express - Construcții & Renovări</h1>
                                        <p>Experiența noastră și angajamentul față de satisfacția clienților ne plasează printre liderii industriei. Fondat în 2017, oferim soluții eficiente și moderne.</p>
                                        <Link to="/servicii" className="theme-btn">
                                            Vezi Serviciile{' '}
                                            <BsArrowRight style={{ marginLeft: '10px' }} />
                                        </Link>
                                        <Link to="/contact" className="theme-btn black">
                                            Contact
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </SwiperSlide>
            </Swiper>
        </section>
    );
}

export default Hero1;
